import { useEffect } from "react";
import {
  Route,
  Routes,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminListLiteralsPage from "./pages/admin/AdminListLiteralsPage";
import AdminListImagesPage from "./pages/admin/AdminListImagesPage";
import BookSimplePage from "./pages/BookSimplePage";
import BookSelectionPage from "./pages/BookSelectionPage";
import NotFoundPage from "./pages/NotFoundPage";
import { Roles, fillsRole } from "../data/roles";
import { useUserData } from "../context/UserDataContext";

const RequireLoginIndex = ({ children }) => {
  const { token, role } = useUserData();
  const isEditorLoggedIn = token !== null && fillsRole(role, Roles.EDITOR);
  return isEditorLoggedIn ? children : <Navigate to={"login"} />;
}

const RequireEditorLogin = ({ children }) => {
  const { token, role } = useUserData();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!token || !fillsRole(role, Roles.EDITOR)) {
      return navigate("/login", { state: { redirect: location } });
    }
  }, [token, navigate, location]);

  return token ? children : null;
};

const AppRoutesEditor = () => {

  const renderIndexRoute = (path, Component) => (
    <Route
      path={path}
      element={
        <RequireLoginIndex>
          <Component />
        </RequireLoginIndex>
      }
    />
  );

  const renderRequireEditorLoginRoute = (path, Component, params) => (
    <Route
      path={path}
      element={
        <RequireEditorLogin>
          <Component {...params} />
        </RequireEditorLogin>
      }
    />
  );

  return (
    <Routes>
      {renderIndexRoute("/", AdminListLiteralsPage)}
      <Route path="/login" element={<AdminLoginPage />} />
      {renderRequireEditorLoginRoute("/list-literals", AdminListLiteralsPage)}
      {renderRequireEditorLoginRoute("/list-images", AdminListImagesPage)}
      {renderRequireEditorLoginRoute("/books", BookSelectionPage)}
      {renderRequireEditorLoginRoute(
        "/books/:bookId/:language/:chapterId",
        BookSimplePage
      )}
      {renderRequireEditorLoginRoute(
        "/books/:bookId/:language/",
        BookSimplePage
      )}
      <Route element={NotFoundPage} />
    </Routes>
  );
}

export default AppRoutesEditor;
